import { render, staticRenderFns } from "./AgentWinloseSimple.vue?vue&type=template&id=d9258484&"
import script from "./AgentWinloseSimple.vue?vue&type=script&lang=js&"
export * from "./AgentWinloseSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports